<template>
  <div
    class="s-service-slider__container"
    :class="{ 's-service-slider__container--full-width': fullWidth }"
    v-if="images?.length"
  >
    <Swiper :options="sliderOptions" ref="swiper" @slideChange="handleChange">
      <SwiperSlide v-for="(image, i) in images" :key="i">
        <img
          :src="image.original_path | image"
          class="s-service-slider__image"
          alt=""
        />
      </SwiperSlide>
    </Swiper>
    <div class="s-service-slider__controls">
      <span class="s-service-slider__count">
        {{ activeIndex + 1 }}/{{ images.length }}
      </span>
      <div class="s-service-slider__buttons">
        <button
          type="button"
          @click="slidePrev"
          class="button-clean s-service-slider__button"
          :class="{ 's-service-slider__button--disabled': activeIndex === 0 }"
        >
          <icon name="arrow-left" />
        </button>
        <button
          type="button"
          @click="slideNext"
          class="button-clean s-service-slider__button"
          :class="{
            's-service-slider__button--disabled':
              activeIndex === images.length - 1
          }"
        >
          <icon name="arrow-left" style="transform: rotate(180deg)" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  name: "ServiceImagesSlider",
  props: {
    images: Array,
    fullWidth: Boolean
  },
  data: () => ({
    sliderOptions: {
      slidesPerView: 1
    },
    activeIndex: 0
  }),
  methods: {
    slidePrev() {
      this.$refs.swiper.$swiper.slidePrev();
    },
    slideNext() {
      this.$refs.swiper.$swiper.slideNext();
    },
    handleChange() {
      this.activeIndex = this.$refs.swiper.$swiper.activeIndex;
    }
  },
  components: {
    Swiper,
    SwiperSlide
  }
};
</script>

<style lang="scss">
@import "swiper/swiper";
.s-service-slider {
  &__container {
    width: 280px;
    @media (max-width: 1000px) {
      width: 180px;
    }
    @media (max-width: 600px) {
      width: 100%;
    }

    .swiper-container {
      margin-bottom: 10px;
    }

    &--full-width {
      width: 100%;

      .s-service-slider__image {
        width: 100%;
        height: auto;
        max-height: 520px;
        object-fit: contain;
      }
    }
  }

  &__controls {
    display: flex;
    justify-content: space-between;
    align-items: center;

    button:first-child {
      margin-right: 10px;
    }
  }

  &__count {
    color: var(--dark-light);
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }

  &__button {
    border-radius: 100%;
    width: 40px;
    height: 40px;
    border: 1px solid var(--gray-dark);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s;

    &--disabled {
      pointer-events: none;
      opacity: 0.5;
    }

    &:hover {
      background: var(--main);
      border-color: var(--main);

      svg {
        color: var(--white);
      }
    }

    svg {
      width: 22px;
      height: 22px;
      transition: 0.2s;
      color: var(--gray-dark);
    }
  }

  &__image {
    width: 280px;
    height: 200px;
    object-fit: contain;
    box-sizing: border-box;
    border: 5px solid var(--main-bg);
    border-radius: 2px;
    @media (max-width: 1000px) {
      width: 180px;
      height: 130px;
    }
    @media (max-width: 600px) {
      width: 100%;
      height: 200px;
    }
  }
}
</style>
